import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../../../connectionString';

@Injectable()
export class RegistationServiceService {

  constructor(private http: HttpClient) { }
  checkEmailIfExist(email: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Register/checkEmail?email='+email);
  }

  registerUser(username: string, password: string,basicFunctionality:string) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/Register/registerUser', { username: username, password: password ,basicFunctionality:basicFunctionality},{  reportProgress: true, observe: 'events' });
  }

}
